import { lazy } from "react";

//#region Pages

const LandingPage = lazy(
  async () =>
    await import("@zenith/pages/LandingPage/landing-page/landing-page")
);
const PaymentLinkPublicPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkPublicPage/payment-link-public-page/payment-link-public-page"
    )
);
const PublicReceiptPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PublicReceiptPage/public-receipt-page/public-receipt-page"
    )
);
const PaymentLinkOverviewPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkOverviewPage/payment-link-overview-page/payment-link-overview-page"
    )
);
const PaymentLinkMethodPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkMethodPage/payment-link-payment-method-page/payment-link-payment-method-page"
    )
);
const PaymentLinkBankTrfDetails = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkOverviewPage/BankTransferPaymentLinkPage/bank-transfer-payment-link-details-page/bank-transfer-payment-link-details-page"
    )
);
const PaymentLinkUssdCodeDetails = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkOverviewPage/UssdCodePaymentLinkPage/ussd-code-payment-link-details-page/ussd-code-payment-link-details-page"
    )
);
const PaymentLinkBankTrfPending = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkOverviewPage/BankTransferPaymentLinkPage/bank-transfer-payment-link-pending-page/bank-transfer-payment-link-pending-page"
    )
);
const PaymentLinkUssdCodePending = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkOverviewPage/UssdCodePaymentLinkPage/ussd-code-payment-link-pending-page/ussd-code-payment-link-pending-page"
    )
);
const PaymentLinkCardPendingPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkOverviewPage/CardPaymentLinkPage/card-payment-link-pending-page/card-payment-link-pending-page"
    )
);
const OpenPaymentLinkAmountPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OpenPaymentLinkPage/OpenPaymentLinkAmountPage/open-payment-link-amount-page/open-payment-link-amount-page"
    )
);
const OpenPaymentLinkMethodPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OpenPaymentLinkPage/OpenPaymentLinkMethodPage/open-payment-link-method-page/open-payment-link-method-page"
    )
);
const OpenPaymentLinkBankTransferPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OpenPaymentLinkPage/OpenPaymentLinkBankTransferPage/open-payment-link-bank-transfer-page/open-payment-link-bank-transfer-page"
    )
);
const OpenPaymentLinkQrCodePage = lazy(
  async () =>
    await import(
      "@zenith/pages/OpenPaymentLinkPage/OpenPaymentLinkQrCodePage/open-payment-link-qr-code-page/open-payment-link-qr-code-page"
    )
);
const OpenPaymentLinkUssdPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OpenPaymentLinkPage/OpenPaymentLinkUssdPage/open-payment-link-ussd-page/open-payment-link-ussd-page"
    )
);
const OpenPaymentLinkCardPendingPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OpenPaymentLinkPage/OpenPaymentLinkCardPendingPage/open-payment-link-card-pending-page/open-payment-link-card-pending-page"
    )
);
const OpenPaymentLinkSuccessPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OpenPaymentLinkPage/OpenPaymentLinkSuccessPage/open-payment-link-success-page/open-payment-link-success-page"
    )
);
const PaymentLinkSuccessPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkSuccessPage/payment-link-success-page/payment-link-success-page"
    )
);
const QRCodePaymentLinkDetailsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkOverviewPage/QRCodePaymentLinkPage/qr-code-payment-link-details-page/qr-code-payment-link-details-page"
    )
);
const QRCodePaymentLinkPendingPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkPage/PaymentLinkOverviewPage/QRCodePaymentLinkPage/qr-code-payment-link-pending-page/qr-code-payment-link-pending-page"
    )
);
const DashboardPage = lazy(
  async () =>
    await import("@zenith/pages/DashboardPage/dashboard-page/dashboard-page")
);
const TransactionsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/TransactionsPage/transactions-page/transactions-page"
    )
);
const TransactionDetailsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/TransactionsPage/transactions-page/TransactionDetailsPage/transaction-details-page/transaction-details-page"
    )
);
const SignInPage = lazy(
  async () => await import("@zenith/pages/SignInPage/sign-in-page/sign-in-page")
);
const SignTwoFactorAuthenticationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SignInPage/two-factor-authentication-code-page/two-factor-authentication-code-page"
    )
);
const SignTwoFaLayout = lazy(
  async () =>
    await import(
      "@zenith/pages/SignInPage/two-factor-authentication-code-page/layout"
    )
);
const ForgotPinPage = lazy(
  async () =>
    await import("@zenith/pages/ForgotPinPage/forgot-pin-page/forgot-pin-page")
);
const PinCreatedPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PinCreatedPage/pin-created-page/pin-created-page"
    )
);
const MobileVerificationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/MobileVerificationPage/mobile-verification-page/mobile-verification-page"
    )
);
const CreateNewPinPage = lazy(
  async () =>
    await import(
      "@zenith/pages/CreateNewPinPage/create-new-pin-page/create-new-pin-page"
    )
);
const AcceptInvitationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/AcceptInvitationPage/accept-invitation-page/accept-invitation-page"
    )
);
const SelectProfilePage = lazy(
  async () =>
    await import(
      "@zenith/pages/SignInPage/select-profile-page/select-profile-page"
    )
);
const PendingSalePage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/PendingSalePage/pending-sale-page"
    )
);
const ConfirmTransferPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/ConfirmTransferPage/confirm-transfer-page"
    )
);
const PaymentsPage = lazy(
  async () =>
    await import("@zenith/pages/PaymentsPage/payments-page/payments-page")
);
const CollectPaymentPage = lazy(
  async () =>
    await import(
      "@zenith/pages/CollectPaymentPage/collect-payment-page/collect-payment-page"
    )
);

const MakePaymentPage = lazy(
  async () =>
    await import(
      "@zenith/pages/CollectPaymentPage/MakePaymentPage/make-payment-page/make-payment-page"
    )
);

const PaymentOverviewPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/payment-overview-page"
    )
);
const PaymentSuccessfulPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentSuccessfulPage/payment-successful-page/payment-successful-page"
    )
);
const SignUpPage = lazy(
  async () => await import("@zenith/pages/SignUpPage/sign-up-page/sign-up-page")
);

const SignUpLoginPinPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SignUp/SignUpLoginPinPage/sign-up-login-pin-page/sign-up-login-pin-page"
    )
);
const SignUpMobileVerificationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SignUp/SignUpMobileVerificationPage/sign-up-mobile-verification-page/sign-up-mobile-verification-page"
    )
);
const SignUpPersonalDetailsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SignUp/SignUpPersonalDetailsPage/sign-up-personal-details-page/sign-up-personal-details-page"
    )
);

const ProfileCreationPage = lazy(
  async () =>
    await import("@zenith/pages/ProfileCreatedPage/profile-created-page")
);
const BusinessRegistrationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-registration-page"
    )
);
const BusinessRegistrationTypePage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-registration-type-page"
    )
);
const BusinessVerificationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-verification-page"
    )
);
const BusinessPersonalDetailsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-personal-details-page"
    )
);
const BusinessPhotoVerificationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-photo-verification-page"
    )
);
const BusinessInformationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-information-page"
    )
);
const BusinessDocumentsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-documents-page"
    )
);
const BusinessPeoplePage = lazy(
  async () =>
    await import("@zenith/pages/BusinessRegistrationpage/business-people-page")
);
const BusinessPeopleVerifyPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-people-verify-page"
    )
);
const BusinessPeopleVerifyEmailLandingPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-people-verify-email-landing-page"
    )
);
const BusinessPeopleVerifyEmailPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-people-verify-email-page"
    )
);
const BusinessAccountPage = lazy(
  async () =>
    await import("@zenith/pages/BusinessRegistrationpage/business-account-page")
);
const BusinessReviewPage = lazy(
  async () =>
    await import("@zenith/pages/BusinessRegistrationpage/business-review-page")
);
const BusinessSubmittingPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-submitting-page"
    )
);
const BusinessUnderReviewPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BusinessRegistrationpage/business-under-review-page"
    )
);
const SignuUpPhotoVerificationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SignUp/SignUpPhotoVerificationPage/sign-up-photo-verification-page/sign-up-photo-verification-page"
    )
);
const SignUpTransactionsPinPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SignUp/SignUpTransactionsPinPage/sign-up-transactions-pin-page/sign-up-transactions-pin-page"
    )
);

const AccountCreatedPage = lazy(
  async () =>
    await import(
      "@zenith/pages/AccountCreatedPage/account-created-page/account-created-page"
    )
);
const UpgradeAccountTierPage = lazy(
  async () =>
    await import(
      "@zenith/pages/UpgradeAccountTierPage/upgrade-account-tier-page/upgrade-account-tier-page"
    )
);
const EndUpgradePage = lazy(
  async () =>
    await import(
      "@zenith/pages/Tiers/EndUpgradePage/end-upgrade-page/end-upgrade-page"
    )
);
const USSDCodePage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/USSDCodePage/ussd-code-page/ussd-code-page"
    )
);
const USSDCodePendingPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/USSDCodePage/ussd-code-pending-page/ussd-code-pending-page"
    )
);
const QRCodePage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/QRCodePage/qr-code-page/qr-code-page"
    )
);
const QRCodePendingPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/QRCodePage/qr-code-pending-page/qr-code-pending-page"
    )
);
const BankTransferPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/BankTransferPage/bank-transfer-page/bank-transfer-page"
    )
);
const BankTransferPendingPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/BankTransferPage/bank-transfer-pending-page/bank-transfer-pending-page"
    )
);
const PaymentLinkPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentOverviewPage/payment-overview-page/PaymentLinkPage/payment-link-page/payment-link-page"
    )
);
const SendMoneyPage = lazy(
  async () =>
    await import("@zenith/pages/SendMoneyPage/send-money-page/send-money-page")
);
const SendMoneyOverviewPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SendMoneyOverviewPage/send-money-overview-page/send-money-overview-page"
    )
);
const SendMoneyTransactionPinPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SendMoneyOverviewPage/send-money-overview-page/SendMoneyTransactionPinPage/send-money-transaction-pin-page/send-money-transaction-pin-page"
    )
);
const SendMoneyAuthenticationCodePage = lazy(
  async () =>
    await import(
      "@zenith/pages/SendMoneyOverviewPage/send-money-overview-page/SendMoneyAuthenticationCodePage/send-money-authentication-code-page/send-money-authentication-code-page"
    )
);
const SendMoneySuccessfulPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SendMoneySuccessfulPage/send-money-successful-page/send-money-successful-page"
    )
);

const OperationConfirmationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OperationConfirmationPage/operation-confirmation-page/operation-confirmation-page"
    )
);

const PaymentLinkConfirmationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PaymentLinkConfirmationPage/payment-link-confirmation-page/payment-link-confirmation-page"
    )
);

const RefundPage = lazy(
  async () => await import("@zenith/pages/RefundPage/refund-page/refund-page")
);
const RefundOverviewPage = lazy(
  async () =>
    await import(
      "@zenith/pages/RefundOverviewPage/refund-overview-page/refund-overview-page"
    )
);
const RefundTransactionPinPage = lazy(
  async () =>
    await import(
      "@zenith/pages/RefundOverviewPage/refund-overview-page/RefundTransactionPinPage/refund-transaction-pin-page/refund-transaction-pin-page"
    )
);
const RefundAuthenticationCodePage = lazy(
  async () =>
    await import(
      "@zenith/pages/RefundOverviewPage/refund-overview-page/RefundAuthenticationCodePage/refund-authentication-code-page/refund-authentication-code-page"
    )
);
const RefundSuccessfulPage = lazy(
  async () =>
    await import(
      "@zenith/pages/RefundSuccessfulPage/refund-successful-page/refund-successful-page"
    )
);
const BeneficiariesPage = lazy(
  async () =>
    await import(
      "@zenith/pages/BeneficiariesPage/beneficiaries-page/beneficiaries-page"
    )
);
const VirtualAccountsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/VirtualAccountsPage/virtual-accounts-page/virtual-accounts-page"
    )
);
const CreateVirtualAccountPage = lazy(
  async () =>
    await import(
      "@zenith/pages/VirtualAccountsPage/create-virtual-account-page/create-virtual-account-page"
    )
);
const VirtualAccountDetailsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/VirtualAccountsPage/virtual-account-details-page/virtual-account-details-page"
    )
);
const OutletManagementPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OutletManagementPage/outlet-management-page/outlet-management-page"
    )
);
const CreateOutletPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OutletManagementPage/outlet-management-page/CreateOutletPage/create-outlet-page/create-outlet-page"
    )
);
const PosTransactionHistoryPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OutletManagementPage/outlet-management-page/OutletDetailsPage/PosDetailsPage/PosTransactionHistoryPage/pos-transaction-history-page/pos-transaction-history-page"
    )
);
const WithdrawalHistoryPage = lazy(
  async () =>
    await import(
      "@zenith/pages/OutletManagementPage/outlet-management-page/OutletDetailsPage/WithdrawalHistoryPage/withdrawal-history-page/withdrawal-history-page"
    )
);
const PosManagementPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PosManagementPage/pos-management-page/pos-management-page"
    )
);
const PosDetailsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PosManagementPage/pos-management-page/PosDetailsPage/pos-details-page/pos-details-page"
    )
);
const PosViewOfferPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PosManagementPage/pos-management-page/PosViewOfferPage/pos-view-offer-page/pos-view-offer-page"
    )
);
const PosRequestReviewPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PosManagementPage/pos-management-page/PosRequestReviewPage/pos-request-review-page/pos-request-review-page"
    )
);
const PosTransactionPinPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PosManagementPage/pos-management-page/PosPaymentMethodPage/pos-payment-method-page/PosRequestTransactionPinPage/pos-request-transaction-pin-page/pos-request-transaction-pin-page"
    )
);
const PosRequestAuthenticationCodePage = lazy(
  async () =>
    await import(
      "@zenith/pages/PosManagementPage/pos-management-page/PosPaymentMethodPage/pos-payment-method-page/PosRequestAuthenticationCodePage/pos-request-authentication-code-page/pos-request-authentication-code-page"
    )
);
const PosRequestSubmitPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PosManagementPage/pos-management-page/PosRequestSubmitPage/pos-request-submit-page/pos-request-submit-page"
    )
);
const PosPaymentMethodPage = lazy(
  async () =>
    await import(
      "@zenith/pages/PosManagementPage/pos-management-page/PosPaymentMethodPage/pos-payment-method-page/pos-payment-method-page"
    )
);
const LoansPage = lazy(
  async () => await import("@zenith/pages/LoansPage/loans-page/loans-page")
);
const LoansSuccessfulPage = lazy(
  async () =>
    await import(
      "@zenith/pages/LoansSuccessfulPage/loans-successful-page/loans-successful-page"
    )
);
const AnalyticsPage = lazy(
  async () =>
    await import("@zenith/pages/AnalyticsPage/analytics-page/analytics-page")
);
const UndoSalePinPage = lazy(
  async () =>
    await import(
      "@zenith/pages/AnalyticsPage/UndoSalePinPage/undo-sale-pin-page"
    )
);
const SettingsPage = lazy(
  async () =>
    await import("@zenith/pages/SettingsPage/settings-page/settings-page")
);
const ProfileManagementPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SettingsPage/profile-management-page/profile-management-page"
    )
);
const TransactionPinPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SettingsPage/transaction-pin-page/transaction-pin-page"
    )
);
const ChangePasswordPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SettingsPage/change-password-page/change-password-page"
    )
);
const TeamManagementPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SettingsPage/team-management-page/team-management-page"
    )
);
const TeamMemberDetailsPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SettingsPage/team-member-details-page/team-member-details-page"
    )
);
const SystemPreferencePage = lazy(
  async () =>
    await import(
      "@zenith/pages/SettingsPage/system-preference/system-preference-page"
    )
);
const NotificationPreferencesPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SettingsPage/notification-preferences-page/notification-preferences-page"
    )
);
const TwoFactorAuthenticationPage = lazy(
  async () =>
    await import(
      "@zenith/pages/SettingsPage/two-factor-authentication-page/two-factor-authentication-page"
    )
);
const StatementsPage = lazy(
  async () =>
    await import("@zenith/pages/StatementsPage/statements-page/statements-page")
);
const InventoryPage = lazy(
  async () =>
    await import("@zenith/pages/InventoryPage/inventory-page/inventory-page")
);

const AddNewProductPage = lazy(
  async () =>
    await import(
      "@zenith/pages/AddNewProductPage/add-new-product-page/add-new-product-page"
    )
);
//#endregion Pages

export {
  AccountCreatedPage,
  AddNewProductPage,
  AnalyticsPage,
  UndoSalePinPage,
  BankTransferPage,
  BankTransferPendingPage,
  BeneficiariesPage,
  VirtualAccountsPage,
  CreateVirtualAccountPage,
  VirtualAccountDetailsPage,
  ChangePasswordPage,
  CollectPaymentPage,
  CreateNewPinPage,
  AcceptInvitationPage,
  SelectProfilePage,
  DashboardPage,
  EndUpgradePage,
  ForgotPinPage,
  InventoryPage,
  LandingPage,
  LoansPage,
  LoansSuccessfulPage,
  MakePaymentPage,
  MobileVerificationPage,
  OutletManagementPage,
  CreateOutletPage,
  PosTransactionHistoryPage,
  WithdrawalHistoryPage,
  PaymentLinkBankTrfDetails,
  PaymentLinkBankTrfPending,
  PaymentLinkCardPendingPage,
  OpenPaymentLinkAmountPage,
  OpenPaymentLinkMethodPage,
  OpenPaymentLinkBankTransferPage,
  OpenPaymentLinkQrCodePage,
  OpenPaymentLinkUssdPage,
  OpenPaymentLinkCardPendingPage,
  OpenPaymentLinkSuccessPage,
  PaymentLinkMethodPage,
  PaymentLinkOverviewPage,
  PaymentLinkPage,
  PaymentLinkPublicPage,
  PublicReceiptPage,
  PaymentLinkSuccessPage,
  PaymentLinkUssdCodeDetails,
  PaymentLinkUssdCodePending,
  PaymentOverviewPage,
  PaymentsPage,
  PendingSalePage,
  ConfirmTransferPage,
  PaymentSuccessfulPage,
  PinCreatedPage,
  PosDetailsPage,
  PosManagementPage,
  PosPaymentMethodPage,
  PosRequestAuthenticationCodePage,
  PosRequestReviewPage,
  PosRequestSubmitPage,
  PosTransactionPinPage,
  PosViewOfferPage,
  ProfileManagementPage,
  QRCodePage,
  QRCodePaymentLinkDetailsPage,
  QRCodePaymentLinkPendingPage,
  QRCodePendingPage,
  RefundAuthenticationCodePage,
  RefundOverviewPage,
  RefundPage,
  RefundSuccessfulPage,
  RefundTransactionPinPage,
  SendMoneyAuthenticationCodePage,
  SendMoneyOverviewPage,
  SendMoneyPage,
  SendMoneySuccessfulPage,
  SendMoneyTransactionPinPage,
  SettingsPage,
  SignInPage,
  SignTwoFactorAuthenticationPage,
  SignTwoFaLayout,
  SignUpLoginPinPage,
  SignUpMobileVerificationPage,
  SignUpPage,
  SignUpPersonalDetailsPage,
  SignUpTransactionsPinPage,
  StatementsPage,
  TeamManagementPage,
  TeamMemberDetailsPage,
  SystemPreferencePage,
  NotificationPreferencesPage,
  TransactionDetailsPage,
  TransactionPinPage,
  TransactionsPage,
  TwoFactorAuthenticationPage,
  UpgradeAccountTierPage,
  USSDCodePage,
  USSDCodePendingPage,
  SignuUpPhotoVerificationPage,
  ProfileCreationPage,
  BusinessRegistrationPage,
  BusinessRegistrationTypePage,
  BusinessVerificationPage,
  BusinessPersonalDetailsPage,
  BusinessPhotoVerificationPage,
  BusinessInformationPage,
  BusinessDocumentsPage,
  BusinessPeoplePage,
  BusinessPeopleVerifyPage,
  BusinessPeopleVerifyEmailLandingPage,
  BusinessPeopleVerifyEmailPage,
  BusinessAccountPage,
  BusinessReviewPage,
  BusinessSubmittingPage,
  BusinessUnderReviewPage,
  OperationConfirmationPage,
  PaymentLinkConfirmationPage,
};
